import React from "react";
import { Oval } from "react-loader-spinner";

const FullPageLoader = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        zIndex: "1000",
        backgroundColor: "rgba(255, 255, 255, 0.5)",
      }}
    >
      <Oval
        visible={true}
        height="80"
        width="80"
        color="#4fa94d"
        ariaLabel="oval-loading"
      />
    </div>
  );
};

export default FullPageLoader;
